import { LookupOptions } from 'hooks/useLookups';

export class Session {
  static parkId: string;
  static lookups: LookupOptions;
};
